var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCr1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 253,
    viewBox: "0 0 260 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.858 125.12C242.791 102.998 235.722 81.5851 223.41 63.176C211.097 44.7669 194.006 30.0565 173.969 20.6225L172.918 22.8554C192.55 32.0986 209.295 46.5114 221.358 64.5481C233.421 82.5847 240.347 103.565 241.393 125.239L243.858 125.12Z",
    stroke: "#A2F8C5",
    strokeOpacity: 0.75,
    strokeWidth: 30
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCr1);
export default __webpack_public_path__ + "static/media/cr1.4d6190b00c450e0720f1e8937f788bee.svg";
export { ForwardRef as ReactComponent };